import React from 'react'
import { Helmet } from 'react-helmet'

interface MetaTitleProps {
  title: string
}

// This component can be tested with an e2e test; snapshot/unit testing is not appropriate.
const MetaTitle: React.FC<MetaTitleProps> = ({ title }): JSX.Element => (
  <Helmet>
    <title>{title}</title>
    <meta name={title} content={`${title} content`} />
  </Helmet>
)

export default MetaTitle
